import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@app/store/reducers/user/userSelectors'

/**
 * Hook to check if conversation approval is enabled
 * First checks the user's use_conversation_approval field,
 * then falls back to the conversationApproval LaunchDarkly flag
 * @returns {boolean} True if conversation approval is enabled, false otherwise
 */
export const useConversationApproval = () => {
  const currentUser = useSelector(selectCurrentUser)
  const isUserConversationApproval = currentUser?.lender?.use_conversation_approval

  return !!isUserConversationApproval
}
